import { jwtDecode } from "jwt-decode";
import { getCookie } from "./cookie";
import { IS_SERVER } from "@/constants";
const OAUTH_COOKIE_NAME = "oauth.access.token";
export const refreshAccessToken = async (oauthRefreshUrl) => {
    try {
        const response = await fetch(`${oauthRefreshUrl}`, {
            credentials: "same-origin",
        });
        if (!response.ok) {
            return false;
        }
        return true;
    }
    catch (error) {
        return false;
    }
};
export const getJwt = async (oauthRefreshUrl) => {
    if (IS_SERVER)
        return { jwt: null, decoded: null };
    const jwt = getCookie(OAUTH_COOKIE_NAME);
    if (jwt == null) {
        return { jwt: null, decoded: null };
    }
    const { valid, expired, decoded } = isValidToken(jwt);
    if (!valid)
        return { jwt: null, decoded: null };
    if (expired) {
        const success = await refreshAccessToken(oauthRefreshUrl);
        if (!success) {
            return { jwt: null, decoded: null };
        }
    }
    return { jwt, decoded };
};
export const isValidToken = (token) => {
    if (IS_SERVER)
        return { valid: false, expired: false, decoded: null };
    try {
        const decoded = jwtDecode(token);
        if (!decoded.exp)
            return { valid: false, expired: false, decoded: null };
        const expDate = new Date(decoded.exp * 1000 || 0);
        const currentDate = new Date();
        currentDate.setSeconds(currentDate.getSeconds() + 30); // 30 second tolerence on token expiration
        return { valid: true, expired: expDate < currentDate, decoded };
    }
    catch (e) {
        return { valid: false, expired: false, decoded: null };
    }
};
